export const DOCUMENT_TYPES = [
  { name: 'Cédula de identidad', code: '2' },
  { name: 'RUT', code: '1' },
  { name: 'Pasaporte', code: '3' },
];
